import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=5670b451&scoped=true&"
import script from "./DateFilter.vue?vue&type=script&lang=js&"
export * from "./DateFilter.vue?vue&type=script&lang=js&"
import style0 from "./DateFilter.vue?vue&type=style&index=0&id=5670b451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670b451",
  null
  
)

export default component.exports